import { Dispatch } from "react";
import { ProjectsAction, Project } from "../../types";

export const addProject = (dispatch: Dispatch<ProjectsAction>, newProject: Project): void =>
  dispatch({
    type: "addProject",
    payload: newProject,
  });

export const setCurrentProject = (dispatch: Dispatch<ProjectsAction>, project: Project): void =>
  dispatch({ type: "setCurrentProject", payload: project });
